import { useEffect, useRef, useState } from "react";
import { supabaseAuth } from "./supabaseClient";
import Login from "./Login";
import App from "./App";

const C = { bg:"#0a0928", green:"#d4fd49" };
const IDLE_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes of inactivity

export default function AuthGate() {
  const [session, setSession] = useState(undefined); // undefined = loading, null = signed out
  const idleTimer = useRef(null);

  useEffect(() => {
    supabaseAuth.auth.getSession().then(({ data }) => setSession(data.session));
    const { data: sub } = supabaseAuth.auth.onAuthStateChange((_event, newSession) => {
      setSession(newSession);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  // Auto sign-out after IDLE_TIMEOUT_MS of no user activity
  useEffect(() => {
    if (!session) return;
    const resetTimer = () => {
      clearTimeout(idleTimer.current);
      idleTimer.current = setTimeout(() => {
        supabaseAuth.auth.signOut();
      }, IDLE_TIMEOUT_MS);
    };
    const events = ["mousedown", "keydown", "scroll", "touchstart", "visibilitychange"];
    events.forEach(evt => window.addEventListener(evt, resetTimer));
    resetTimer();
    return () => {
      clearTimeout(idleTimer.current);
      events.forEach(evt => window.removeEventListener(evt, resetTimer));
    };
  }, [session]);

  if (session === undefined) {
    return (
      <div style={{background:C.bg,minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",color:C.green,fontFamily:"'Mulish',sans-serif"}}>
        Loading...
      </div>
    );
  }

  if (!session) {
    return <Login onLogin={setSession} />;
  }

  return <App session={session} onSignOut={() => supabaseAuth.auth.signOut()} />;
}
